import {Injectable} from '@angular/core';
import {UserService} from '@services/user/user.service';

@Injectable()
export class TermsOfUseModel {
  acceptedDate: string;

  constructor(private userService: UserService) {
    this.acceptedDate = '';
  }

  public initModel() {
    this.getAcceptTermsOfUse()

  }

  public getAcceptTermsOfUse() {
    this.userService.AcceptTermsOfUseGet().subscribe((res: any) => {
      this.acceptedDate = res.json.data.acceptDetails.acceptDate;
    });
  }
}

